import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import FormControl from 'bee-form-control';
import { Input as FormControl } from '@tinper/next-ui';
import { NEED_SELECTION_ITEMS } from './constants';
import {
    isArrowKeyDown,
    ctrlKeyWithUpDown,
    isEnterKeyDown,
    toast,
    getMultiLang,
} from '@platform/api';
import WithKeyboardChange from '../WithKeyboardChange';
import { getSysFieldid } from '@platform/api';

const { processCursorPointInSide } = WithKeyboardChange;

// require('bee-form-control/build/FormControl.css');
// require('bee-icon/build/Icon.css');
require('./index.less');
// 判断是否是url
function IsURL(str_url) {
    str_url = String(str_url);
    var strRegex = "^((https|http|ftp|rtsp|mms)?://)" +
        "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" + //ftp的user@ 
        "(([0-9]{1,3}\.){3}[0-9]{1,3}" + // IP形式的URL- 199.194.52.184 
        "|" + // 允许IP和DOMAIN（域名）
        "([0-9a-z_!~*'()-]+\.)*" + // 域名- www. 
        "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\." + // 二级域名 
        "[a-z]{2,6})" + // first level domain- .com or .museum 
        "(:[0-9]{1,4})?" + // 端口- :80 
        "((/?)|" + // a slash isn't required if there is no file name 
        "(/[0-9a-zA-Z_!~*'().;?:@&=+$,%#-]+)+/?)$";
    var re = new RegExp(strRegex);
    //re.test()
    if (re.test(str_url)) {
        return (true);
    } else {
        return (false);
    }
}
export default class NCFormControl extends Component {
    constructor(props) {
        super(props);
        this.chineseEntering = false;
        this.state = {
            json: {},
            readOnly: this.props.type === 'password' ? true : false,
        };
        this.keyFlag = 0;
    }

    componentWillMount() {
        // 初始化调用getPlatformLang方法获取多语
        let callback = json => {
            this.setState({ json });
        };
        getMultiLang({ moduleId: 'base_text_check', callback }); // moduleId为所需加载json文件夹名称前缀
    }

    componentDidMount() {
        let { maxlength, isCheckChinese, itemtype, watchPaste } = this.props;
        let inputElement = ReactDOM.findDOMNode(this.i);
        let inputNode = inputElement.querySelector('input') || inputElement;
        if (
            this.i &&
            ((maxlength && isCheckChinese) || itemtype === 'residtxt')
        ) {
            inputNode.addEventListener(
                'compositionstart',
                this.setInputFlag.bind(this, inputNode, true),
                false,
            );
            inputNode.addEventListener(
                'compositionend',
                this.setInputFlag.bind(this, inputNode, false),
                false,
            );
        }
        watchPaste &&
            inputNode.addEventListener(
                'paste',
                event => this.handlePaste(event),
                false,
            );
    }

    setInputFlag = (inputNode, flag, e) => {
        //处理中文输入
        this.chineseEntering = flag;
        if (flag === false) {
            let { maxlength, onChange } = this.props;
            let value = inputNode.value;
            if (value && maxlength) {
                value = this.getCalcText(value, maxlength);
            }
            if (typeof onChange === 'function') {
                inputNode.value = value;
                e.target.value = value;
                console.log('事件对象e', e.target.value);
                onChange(value, e, flag);
            }
        }
    };

    /**
     * @author bbqin
     */
    componentDidUpdate() {
        // TODO  目前逻辑在 setstate后
        // TODO 做一些事件绑定的工作
        // typeof Message ? Message.listen('', this.)
        if (this.focusFlag) {
            if (this.i) {
                let inputElement = ReactDOM.findDOMNode(this.i);
                let inputNode =
                    inputElement.querySelector('input') || inputElement;
                inputNode.focus();
            }
        }
        this.focusFlag = false;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.type !== this.props.type && nextProps.type === 'text') {
            this.keyFlag = this.keyFlag + 1;
            this.focusFlag = true;
        }
    }

    componentWillUnmount() {
        let { maxlength, isCheckChinese, watchPaste } = this.props;
        if (this.i && maxlength && isCheckChinese) {
            let inputElement = ReactDOM.findDOMNode(this.i);
            let inputNode = inputElement.querySelector('input') || inputElement;
            inputNode.removeEventListener(
                'compositionstart',
                this.setInputFlag.bind(this, inputNode, true),
                false,
            );
            inputNode.removeEventListener(
                'compositionend',
                this.setInputFlag.bind(this, inputNode, false),
                false,
            );
            watchPaste &&
                inputNode.removeEventListener(
                    'paste',
                    event => this.handlePaste(event),
                    false,
                );
        }
    }

    /**
     * @author bbqin
     */
    handleFocus = (value, e) => {
        const { onFocus, itemtype, type, needSelect } = this.props;
        if (type === 'password') {
            this.setState({ readOnly: false });
        }
        // 公式编辑器的问题  已经放到公式编辑器内部处理了  这里最好少做限制
        onFocus && onFocus(e, value);
        // }
        //this.mouseDown 表示用户用鼠标点击此组件
        this.mouseDown !== true &&
            (NEED_SELECTION_ITEMS.includes(itemtype) || needSelect) &&
            this.executeSelection(e);
    };

    executeSelection(e) {
        let length = e.target.value.length;
        e.target.setSelectionRange(0, length);
    }

    handlePaste = event => {
        let pasteContent = event.clipboardData.getData('text/plain');
        if (pasteContent.length > 2) {
            var endStr = pasteContent.substr(
                pasteContent.length - 1,
                pasteContent.length,
            );
            if (endStr === '\n') {
                pasteContent = pasteContent.substr(0, pasteContent.length - 1);
            }
            if (
                pasteContent.substr(
                    pasteContent.length - 1,
                    pasteContent.length,
                ) === '\r'
            ) {
                pasteContent = pasteContent.substr(0, pasteContent.length - 1);
            }
        }
        // 多列取第一列
        let reg = /\t/;
        let text = [];
        if (reg.test(pasteContent)) {
            let rows = pasteContent.split('\r\n') || [];
            rows.forEach(row => {
                let cells = row.split('\t') || [];
                let firstCell = cells[0];
                text.push(firstCell);
            });
        } else {
            text = pasteContent.split('\r\n');
        }
        let selectionStart = event.target.selectionStart;
        let selectionEnd = event.target.selectionEnd;
        let oldValue = this.props.value ?? '';
        let result = oldValue.slice(0, selectionStart) + text.join(',') + oldValue.slice(selectionEnd);
        this.setState({ value: result });
        let inputNode = ReactDOM.findDOMNode(this.i);
        inputNode.value = result;
        this.setInputFlag(inputNode, false, event);
        event.preventDefault();
    };

    handleBlur = (value, e) => {
        //let value = typeof e === 'object' ? e.target.value : e;
        this.mouseDown = false;
        // verifyClear 正则校验失败默认清空输入
        const {
            onBlur,
            type,
            onChange,
            trim = false,
            reg,
            regMessage,
            verifyClear = true,
            toastContainer,
            hyperlinkflag,
            hyperlinktype,
        } = this.props;
        const { json } = this.state;
        if (type === 'password') {
            this.setState({ readOnly: true });
        }

        if (hyperlinkflag && hyperlinktype == "1") {

            if (value && !IsURL(value)) {
                toast({
                    mark: "hyperlink-wraning",
                    color: "danger",
                    title: json["base-maxlength-check-title"],
                    content: json["base-invalid-hyperlink-url"],
                });
                onChange && onChange("", e);
                onBlur && onBlur("", e);
                return false;
            }
        }
        if (value && reg && verifyClear) {
            let result = false;
            // 复杂的身份证校验，正则搞不定，传进来一个function
            if (Object.prototype.toString.call(reg) === '[object Function]') {
                result = !reg(value);
            }
            // 普通的正则校验
            if (Object.prototype.toString.call(reg) === '[object RegExp]') {
                result = !reg.test(value);
            }
            if (result) {
                toast({
                    mark: 'input-reg-tip',
                    color: 'danger',
                    title: json['base-maxlength-check-title'],
                    content: regMessage || json['base-reg-check-content'],
                    container: toastContainer,
                });
                onChange && onChange('', e);
                onBlur && onBlur('', e);
                return false;
            }
        }
        value = String(value);
        let needTrim = value.startsWith(' ') || value.endsWith(' ');
        if (trim === true && needTrim && type !== 'password') {
            onChange && onChange(value.trim(), e);
        }
        onBlur && onBlur(value.trim(), e);
    };

    // icon clock event
    closeClick = e => {
        this.i.clearValue(e);
        if (
            this.i.props.clearSearch &&
            Object.prototype.toString
                .call(this.i.props.clearSearch)
                .slice(8, 16) === 'Function'
        ) {
            this.i.props.clearSearch(e);
        }
    };

    searchClick = e => {
        this.i.props.onSearch && this.i.props.onSearch(this.i.props.value, e);
    };

    mySearch = e => {
        if (e.keyCode === 13) {
            this.i.props.onSearch &&
                this.i.props.onSearch(this.i.props.value, e);
        }
    };

    onChange = (val, e) => {
        let {
            onChange,
            showMax,
            max,
            componentClass,
            maxlength,
            isCheckChinese,
        } = this.props;
        if (typeof onChange === 'function') {
            if (
                showMax &&
                typeof max === 'number' &&
                componentClass === 'textarea'
            ) {
                if (val.length > max) {
                    return;
                }
            }

            if (
                isCheckChinese &&
                this.chineseEntering === false &&
                maxlength &&
                val
            ) {
                //其他输入法
                val = this.getCalcText(val, maxlength);
            }
            onChange(val, e, this.chineseEntering);
            this.chineseEntering = false;
        }
    };

    getCalcText = (value, maxlength) => {
        maxlength = Number(maxlength);
        let { json } = this.state;
        let { toastContainer } = this.props;
        let valLength = 0;
        // 将字符串转换为二进制数据计算长度
        let encoder;
        if (window.TextEncoder) {
            encoder = new TextEncoder();
            valLength = value.split('').reduce((total, pre) => { return total + encoder.encode(String(pre)).length; }, 0);
            // valLength = encoder.encode(String(value)).length;
        } else {
            // 中文下有个特殊字符 数据库里占用的是两个字符
            valLength = String(value).replace(
                /\·|[^\x00-\xff]/gi,
                '---',
            ).length;
        }
        
        if (typeof maxlength === 'number' && valLength > maxlength) {
            let sum = 0;
            let charNum = 0; 
            for (let index = 0; index < value.length; index++) {
                const element = value[index];
                if (encoder) {
                    let cLen = encoder.encode(element).length || 3;
                    sum = sum + cLen;
                } else {
                    if (/\·|[^\x00-\xff]/.test(element)) {
                        sum = sum + 3;
                    } else {
                        ++sum;
                    }
                }
                if (sum > maxlength) {
                    charNum = index;
                    break;
                }
            }
            value = value.substring(0, charNum);
            if (json) {
                console.log('执行气泡提示');
                let { maxlengthMsg } = this.props;
                let content =
                    maxlengthMsg ||
                    json['base-maxlength-check-content1'] +
                        maxlength +
                        '(' +
                        json['base-maxlength-check-content2'] +
                        Math.floor(maxlength / 3) +
                        json['base-maxlength-check-content3'] +
                        ')';
                toast({
                    mark: 'input-maxlength-tip',
                    color: 'danger',
                    title: json['base-maxlength-check-title'],
                    content,
                    container: toastContainer,
                });
            }
        }
        return value;
    };

    handleKeyDown = e => {
        let { renderInTable, hotKeyWithArrow, onEnter, value } = this.props;
        let { target } = e;
        // e.stopPropagation();
        if (isEnterKeyDown(e)) {
            onEnter && onEnter({ e, value });
        }

        //判断control + 上下键
        if (renderInTable && ctrlKeyWithUpDown(e)) {
            e.keyCode === 38
                ? target.setSelectionRange(-1, 0)
                : target.setSelectionRange(
                    target.value.length,
                    target.value.length,
                );
        }

        //如果按了上下键就直接切换焦点
        if (renderInTable && isArrowKeyDown(e, [38, 40])) {
            hotKeyWithArrow && hotKeyWithArrow({ e });
            return;
        }

        //如果是全选了文字就切换光标
        let selectionValue = document.getSelection().toString();
        if (isArrowKeyDown(e, [37, 39]) && selectionValue === target.value) {
            hotKeyWithArrow && hotKeyWithArrow({ e });
            return;
        }

        //如果是左右键判断是否是选中了所有文字或判断光标在是否在最左侧||最右侧
        if (isArrowKeyDown(e, [37, 39])) {
            processCursorPointInSide(hotKeyWithArrow, e);
            return;
        }
    };

    render() {
        let {
            isViewMode,
            showMax = false,
            max,
            className,
            wrapperClassName = '',
            onBlur,
            showStar,
            value,
            type,
            showClose = false,
            disabled,
            onEnter,
            fieldid,
            required,
            componentClass,
            onChange,
            onFocus,
            maxlength,
            isCheckChinese = false,
            onKeyDown,
            ...others
        } = this.props;
        let flag = false;

        if (!fieldid && type === 'search') {
            fieldid = 'search';
        }

        if (type === 'search') {
            flag = true;
            // type = 'text';
        } else if (type === 'password') {
            let { title, ...otherss } = others;
            others = otherss;
        }
        if (value === undefined || value === null) {
            value = '';
        }
        //钉耙底层有做限制
        // if (others.hasOwnProperty('maxlength') && others.maxlength > 0) {
        // 	value = String(value).slice(0, others.maxlength);
        // }

        let count = value.length;

        //wrapperClassName = wrapperClassName || className;

        // NCC-195120 componentClass == 'textarea' 样式处理
        let textareaWrapper =
            componentClass === 'textarea'
                ? 'base-form-textarea-control-wrapper'
                : '';
        return isViewMode ? (
            <span>{value}</span>
        ) : (
            <div
                style={{
                    display: 'inline-block',
                    height: componentClass == 'textarea' && 'auto',
                }}
                className={`base-form-control-wrapper formcontrol-hotkey-wrapper ${textareaWrapper} ${wrapperClassName}`}
                onKeyDown={this.handleKeyDown}
                onMouseDown={() => {
                    this.mouseDown = true;
                }}
            >
                {showStar ? (
                    <span className="form-control-required-tag">*</span>
                ) : (
                    ''
                )}
                <FormControl
                    key={this.keyFlag}
                    fieldid={getSysFieldid(fieldid) || null}
                    ref={i => (this.i = i)}
                    // 这可不能瞎去，影响了表单tab键跳转
                    className={`base-input ${
                        disabled ? 'base-input-disabled' : ''
                    } ${className}`}
                    onBlur={this.handleBlur}
                    value={value}
                    type={type}
                    autocomplete="off"
                    readOnly={this.state.readOnly}
                    // onKeyUp={this.mySearch}
                    disabled={disabled}
                    componentClass={componentClass}
                    showClose={flag ? true : showClose} // 保留type="search"时 显示清空icon的逻辑
                    onFocus={this.handleFocus}
                    onChange={this.onChange}
                    onKeyDown={e => {
                        this.handleKeyDown(e);
                        onKeyDown && onKeyDown(e);
                    }}
                    maxlength={!isCheckChinese && maxlength}
                    {...others}
                    spellCheck="false"
                />
                {/* {flag ? (
                    <div className="base-form-control-search-text">
                        {' '}
                        {value.length && !disabled ? <i onClick={this.closeClick} className="iconfont icon-qingkong " /> : null}{' '}
                        升级了bee-form-control，type="search"会自带搜索icon 搜索回调仍为onSearch
                        <i onClick={this.searchClick} className="iconfont icon-sousuo" /> 
                    </div>
                ) : null}  */}

                {showMax && componentClass == 'textarea' && (
                    <div className="form-control-textarea-countClass">
                        <span>{count || 0}</span>
                        <span>/{max}</span>
                    </div>
                )}
            </div>
        );
    }
}

NCFormControl.TextArea = FormControl.TextArea;
// NCFormControl.Search = FormControl.Search;
// NCFormControl.Password = FormControl.Password;
// NCFormControl.Group = FormControl.Group;
